
import CustomModal from './CustomModal.vue';
import CloseIcon from '../icons/CloseIcon.vue';
import { mapActions, mapGetters } from 'vuex';
import { appURLs, inAppRedirect } from '@/utils/route-redirects';
import Button from '../atom/buttons/Button.vue';
import { portfolioUniqueNameError } from '~/utils/behavior/portfolio-creation';
//TODO - Disabled for now, to uncomment when we enable the league rank change notifications in the api
// import Toggle from './Toggle.vue';
import { isPortfolioOwner } from '~/utils/portfolio-role-checks';

export default {
  name: 'PortfolioSettingsModal',
  components: { CustomModal, CloseIcon, Button },

  data() {
    return {
      newName: '',
      newDescription: '',
      nameAlreadyInUse: '',
      isDescriptionValid: '',
      loading: false,
      portfolioUniqueNameError,
    };
  },

  computed: {
    ...mapGetters('modals', ['portfolioSettingsModal']),
    ...mapGetters('portfolio', ['getMyPortfoliosRes']),

    portfolio() {
      return this.portfolioSettingsModal?.portfolio || {};
    },
    isPortfolioOwner() {
      return isPortfolioOwner(this.portfolio?.portfolioUserRole);
    },
    disableNotificationsToggle() {
      return (
        !this.portfolio?.leagueId ||
        !this.portfolio?.leagueAllowsRankChangeNotifications
      );
    },
  },

  watch: {
    portfolio: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.newName = newVal.name || '';
          this.newDescription = newVal.description || '';
        }
      },
    },
  },

  methods: {
    ...mapActions('modals', ['showPortfolioSettingsModal']),
    ...mapActions('portfolio', [
      'updatePortfolio',
      'deletePortfolio',
      'getMyPortfolios',
      'updatePortfolioName',
      'updatePortfolioDescription',
    ]),

    handleClosePortfolioSettingsModal() {
      this.showPortfolioSettingsModal({
        portfolio: null,
        show: false,
      });
    },

    handleSavePortfolio() {
      return this.updatePortfolio({
        portfolioId: this.portfolio.id,
        data: { name: this.newName, description: this.newDescription },
      });
    },

    handleSavePortfolioDesc() {
      return this.updatePortfolio({
        portfolioId: this.portfolio.id,
        data: { description: this.newDescription },
      });
    },

    handlePortfolioNameValidation() {
      this.nameAlreadyInUse = !!this.getMyPortfoliosRes.data.portfolios.some(
        (p) => p.name === this.newName && p.id !== this.portfolio.id
      );
    },

    handlePortfolioDescriptionValidation() {
      this.isDescriptionValid =
        !!this.newDescription && this.newDescription.length <= 100;
    },

    async handleSavePortfolioNameAndDesc() {
      await this.handleSavePortfolio().then(() => {
        this.updatePortfolioName(this.newName);
        this.updatePortfolioDescription(this.newDescription);
        this.$emit('onBackSuccess');
      });
    },

    async handleDeletePortfolio() {
      if (confirm(this.$t('portfolio_delete_confirmation'))) {
        this.loading = true;

        await this.deletePortfolio(this.portfolio.id);
        await this.getMyPortfolios();

        this.loading = false;
        this.handleClosePortfolioSettingsModal();

        inAppRedirect(this.localePath(appURLs.portfolios()));
      }
    },
  },
};
